import React, { useMemo, useState } from 'react';
import { DetalheCockpit } from '../utils/auditoriaCockpitDetalhe';

interface Props {
  detalhe: DetalheCockpit | null;
  onFechar: () => void;
}

// COR-272: modal do cockpit — abre ao clicar em qualquer AuditoriaGauge, listando tudo que
// compõe o número exibido (por módulo, por tributo, por conta, conforme o indicador). Campo de
// busca client-side sobre todas as colunas — ajuda o usuário a identificar rápido o que procurar
// no filtro principal ("Tipo de Auditoria") da tela.
const AuditoriaCockpitDetalheModal: React.FC<Props> = ({ detalhe, onFechar }) => {
  const [busca, setBusca] = useState('');

  const linhasFiltradas = useMemo(() => {
    if (!detalhe) return [];
    if (!busca.trim()) return detalhe.linhas;

    const termo = busca.trim().toLowerCase();
    return detalhe.linhas.filter(linha =>
      Object.values(linha).some(valor => String(valor ?? '').toLowerCase().includes(termo))
    );
  }, [detalhe, busca]);

  if (!detalhe) return null;

  return (
    <div className='auditoria-cockpit-modal-backdrop' onClick={onFechar}>
      <div className='auditoria-cockpit-modal' onClick={e => e.stopPropagation()} role='dialog' aria-modal='true' aria-label={detalhe.titulo}>
        <div className='auditoria-cockpit-modal-header'>
          <div>
            <h4>{detalhe.titulo}</h4>
            <p className='text-muted mb-0' style={{ fontSize: '0.85rem' }}>{detalhe.descricao}</p>
          </div>
          <button type='button' className='btn-close' aria-label='Fechar' onClick={onFechar} />
        </div>

        {detalhe.linhas.length > 0 && (
          <div className='auditoria-cockpit-modal-busca'>
            <i className='bi bi-search me-2 text-muted' />
            <input
              type='text'
              className='form-control form-control-sm'
              placeholder='Buscar nesta lista (qualquer coluna)...'
              value={busca}
              onChange={e => setBusca(e.target.value)}
              autoFocus
            />
            <span className='text-muted' style={{ fontSize: '0.78rem', whiteSpace: 'nowrap' }}>
              {linhasFiltradas.length} de {detalhe.linhas.length}
            </span>
          </div>
        )}

        <div className='auditoria-cockpit-modal-body'>
          {detalhe.linhas.length === 0 ? (
            <div className='text-muted text-center py-5'>{detalhe.textoVazio}</div>
          ) : linhasFiltradas.length === 0 ? (
            <div className='text-muted text-center py-5'>Nenhum resultado para &quot;{busca}&quot;.</div>
          ) : (
            <div className='table-responsive'>
              <table className='table table-sm table-row-dashed table-row-gray-200 align-middle gs-0 gy-2'>
                <thead>
                  <tr className='fw-bolder text-muted'>
                    {detalhe.colunas.map(coluna => (
                      <th
                        key={coluna.chave}
                        className={
                          coluna.alinhamento === 'right' ? 'text-end' :
                          coluna.alinhamento === 'center' ? 'text-center' : ''
                        }
                      >
                        {coluna.rotulo}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {linhasFiltradas.map((linha, i) => (
                    <tr key={i}>
                      {detalhe.colunas.map(coluna => (
                        <td
                          key={coluna.chave}
                          className={
                            coluna.alinhamento === 'right' ? 'text-end' :
                            coluna.alinhamento === 'center' ? 'text-center' : ''
                          }
                        >
                          {linha[coluna.chave] ?? '-'}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuditoriaCockpitDetalheModal;
